<template>
  <div class="app-footer">
    <footer class="container-fluid">
      <b-row>
        <b-col class="text-center">
          <p class="text-white mt-4">
            <a href="https://github.com/google/blockly">
              <img
                class="mb-3"
                :src="require('../static/built_on_blockly.png')"
                alt="Built on Blockly"
                height="50"
              />
            </a>
            <br />
            CodingBee.my &copy; 2019. All Rights Reserved.
            <br />
            <a class="text-white" href="https://codingbee.my">
              Home
            </a>
            |
            <a class="text-white" href="https://codingbee.my/terms">
              Terms
            </a>
            |
            <a class="text-white" href="https://codingbee.my/privacy">
              Privacy
            </a>
          </p>
        </b-col>
      </b-row>
    </footer>
  </div>
</template>

<script>
export default {
  name: "AppFooter"
};
</script>

<style lang="less" scoped>
.app-footer {
  background-color: #292929;
}
</style>
